import type { MatchLog, Player } from '@/types/domain';

export const sumValues = (arr: number[] = []): number => {
  let total = 0;
  for (const value of arr) total += value;
  return total;
};

export const secondsToTime = (
  duration: number,
): { seconds: string; minutes: string; hours: string } => {
  // https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
  const date = new Date(0);
  date.setSeconds(parseInt(duration as unknown as string));
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // See https://bobbyhadz.com/blog/javascript-pad-number-with-leading-zeros
  return {
    seconds: String(seconds).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
  };
};

/** Converts the array from Match State players into the array shape a Craft CMS GraphQL mutation expects. */
interface LineUpMutationRow {
  col1: unknown;
  col2: unknown;
  col3?: unknown;
}

export const convertLineUpForMutation = (
  data: Player[] | undefined,
  visible: boolean | undefined,
): LineUpMutationRow[] => {
  const array: LineUpMutationRow[] = [];
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
  for (const [i, o] of data!.entries()) {
    array[i] = {
      col1: o.uuid,
      col2: o.name,
    };
    if (Object.keys(o).length >= 3) {
      array[i].col3 = o.playingTime
        ? visible
          ? Math.round(parseInt(o.playingTime as string) / 60)
          : o.playingTime
        : 0;
    }
  }

  return array;
};

interface LogMutationRow {
  col1: unknown;
  col2: unknown;
  col3: unknown;
}

export const convertLogsForMutation = (data: MatchLog[]): LogMutationRow[] => {
  const array: LogMutationRow[] = Array.from(data, (o) => ({
    col1: o.type,
    col2: o.note,
    col3: o.date,
  }));

  return array;
};

interface LogNoteElement {
  note: string;
  [key: string]: unknown;
}

export const updateOrInsertLogNotes = (
  array: LogNoteElement[],
  element: LogNoteElement,
): LogNoteElement[] => {
  if (array.length === 0) {
    array.push(element);
  } else {
    const i = array.findIndex(
      (_element) =>
        _element.note.split(':', 1)[0] === element.note.split(':', 1)[0],
    );
    if (i === -1) {
      array.push(element);
    } else {
      array[i] = element;
    }
  }
  return array;
};
